import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { Hero } from "../components/Hero";
import { BrandStory } from "../components/BrandStory";
import { FightFundCounter } from "../components/FightFundCounter";
import { PhotographyNote } from "../components/PhotographyNote";
import { Manifesto } from "../components/Manifesto";
import { EditorialMarquee } from "../components/EditorialMarquee";
import { api, fmtPrice } from "../lib/api";

const ease = [0.22, 1, 0.36, 1];

const FeaturedGrid = ({ products }) => {
  if (!products.length) return null;
  return (
    <section data-testid="featured" className="w-full mx-auto px-4 sm:px-8 md:px-12 py-24 md:py-32">
      <div className="flex flex-col md:flex-row md:items-end justify-between mb-14 gap-6">
        <div>
          <p className="label text-[#6A7180] mb-4">// In Stock Now</p>
          <h2 className="font-serif-display text-5xl sm:text-7xl leading-[0.9]">The Drop</h2>
        </div>
        <Link to="/shop" className="label link-underline">View everything →</Link>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-12 gap-px bg-[#D4D7DD]">
        {products.slice(0, 4).map((p, i) => {
          const spans = ["md:col-span-7", "md:col-span-5", "md:col-span-5", "md:col-span-7"];
          const ratios = ["aspect-[4/5]", "aspect-[4/5]", "aspect-[4/5]", "aspect-[4/5]"];
          return (
            <motion.div
              key={p.id}
              initial={{ opacity: 0 }} whileInView={{ opacity: 1 }} viewport={{ once: true }}
              transition={{ duration: 0.9, ease, delay: i * 0.05 }}
              className={`${spans[i]} bg-[#EDEEF1] p-6 md:p-10`}
            >
              <Link to={`/product/${p.slug}`} className="group block">
                <div className={`overflow-hidden bg-[#E2E4E8] ${ratios[i]}`}>
                  <img src={p.image} alt={p.name} className="w-full h-full object-cover transition-transform duration-[900ms] ease-out group-hover:scale-105" />
                </div>
                <div className="flex justify-between items-baseline mt-5">
                  <h3 className="font-serif-display text-2xl md:text-3xl group-hover:italic transition-all">{p.name}</h3>
                  <span className="text-sm">{fmtPrice(p.price)}</span>
                </div>
                <p className="label text-[#8A8F99] mt-1">{p.category}</p>
              </Link>
            </motion.div>
          );
        })}
      </div>
    </section>
  );
};

export default function Home() {
  const [featured, setFeatured] = useState([]);
  useEffect(() => {
    api.get("/products").then((r) => {
      const all = Array.isArray(r.data) ? r.data : [];
      // Newest products first (backend sorts by created_at desc) so anything you add shows here.
      setFeatured(all);
    }).catch(() => {});
  }, []);

  return (
    <div data-testid="home-page">
      <Hero />
      <BrandStory />
      <FightFundCounter />
      <FeaturedGrid products={featured} />
      <PhotographyNote />
      <EditorialMarquee />
      <Manifesto />
    </div>
  );
}
